export default __webpack_public_path__ + "static/O0222-c02c94bac82ea3430fe419b17ee825ff.png";